import { useFeatureFLags, useWritableFlagStore } from '~/hooks/useFeatureFlags';
import { Checkbox, SecondaryButton } from '@rikstv/shared-components';
import styles from './feature-flag-panel.module.css';
import config from '~/config';

const renderPanel =
  localStorage.getItem('ld-panel') != null || config.environment === 'dev' || globalThis.location?.href?.includes('ld-panel');

export const FeatureFlagControlPanel = () => {
  const flags = useFeatureFLags();
  if (!renderPanel) {
    return null;
  }
  const onChange = (key: string, value: boolean) => {
    useWritableFlagStore.setState({ [key]: value });
  };
  return (
    <div>
      <SecondaryButton popoverTarget="ld-popover" className={styles.button}>
        <LDIcon />
      </SecondaryButton>
      <div id="ld-popover" className={styles.popover} popover="auto">
        <b>Feature Flags</b>
        <main>
          {Object.entries(flags).map(([key, value]) => (
            <div key={key}>
              <Checkbox checked={value} onChange={(e) => onChange(key, e.target.checked)}>
                {key.replace('rtvWeb', '')}
              </Checkbox>
            </div>
          ))}
        </main>
      </div>
    </div>
  );
};

const LDIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="-.00348466 0 256.88728835 255.31014671" width={2500}>
    <title>LaunchDarkly</title>
    <path d="m129.865 255.306a5.637 5.637 0 0 1 -5.073-3.157 5.355 5.355 0 0 1 .507-5.637l59.98-82.584-105.02 42.899a5.778 5.778 0 0 1 -2.255.479 5.637 5.637 0 0 1 -5.384-4.059 5.412 5.412 0 0 1 2.311-6.172l92.365-54.54-162.632-9.357a5.637 5.637 0 0 1 0-11.106l162.717-9.33-92.393-54.538a5.412 5.412 0 0 1 -2.311-6.173 5.637 5.637 0 0 1 5.355-4.059c.78-.003 1.55.17 2.255.507l105.048 42.955-59.98-82.555a5.355 5.355 0 0 1 -.507-5.638 5.637 5.637 0 0 1 5.046-3.241c1.48.01 2.894.62 3.917 1.691l119.536 119.509a9.076 9.076 0 0 1 0 12.824l-119.592 119.648a5.442 5.442 0 0 1 -3.89 1.634z" />
  </svg>
);
